import React, { Component } from 'react'
import ReactTable from 'react-table'
import { Input, InputNumber, Form, Button, AutoComplete, Icon, Tooltip, Popconfirm } from 'antd'
import numeral from 'numeral'
import { convertToOption, filterCaseInsensitive } from '../util'
import _ from 'lodash'
import ItemQuickAdd from './item/ItemQuickAdd'
import { generateUniqueId } from '../util'

const FormItem = Form.Item

class PurchaseOrderSection extends Component {
  constructor(props) {
    super(props)
    this.state = {
      panel: 'TablePanel',
      editMode: -1,
      itemQuickAddModal: false,
      itemsToAdd: []
    }
  }

  isEditAllowed = () => {
    return this.props.allowEdit || false
  }

  getSectionItems = id => {
    const { purchaseOrderItems, index } = this.props
    return purchaseOrderItems.filter(
      item =>
        (item.purchase_order_section_id === id ||
          item.estimate_section_id === id ||
          item.estimate_section_template_id === id ||
          item.purchase_order_section_id === index) &&
        !item.markedForDeletion
    )
  }

  changeSectionPanel = panel => {
    this.setState({
      panel: panel
    })
  }

  addItem = () => {
    const addItems = this.state.itemsToAdd
    addItems.push({ id: generateUniqueId() })
    this.setState({
      itemsToAdd: addItems
    })
  }

  removeAddItem = item => {
    const addItems = this.state.itemsToAdd
    addItems.splice(addItems.indexOf(item), 1)
    this.setState({
      itemsToAdd: addItems
    })
  }

  handleAddNewItem = item => {
    const { form } = this.props
    form.validateFields(
      [`item_id-${item.id}`, `description-${item.id}`, `quantity-${item.id}`, `cost-${item.id}`],
      (err, values) => {
        if (!err) {
          let index = this.props.sectionId ? this.props.sectionId : this.props.index
          this.props.addItem(index, {
            item_id: values[`item_id-${item.id}`],
            description: values[`description-${item.id}`],
            quantity: values[`quantity-${item.id}`],
            cost: values[`cost-${item.id}`]
          })
          this.removeAddItem(item)
        }
      }
    )
  }

  saveAllItems = () => {
    if (this.state.itemsToAdd.length > 0) {
      let auxArray = this.state.itemsToAdd.slice(0)
      auxArray.forEach(item => this.handleAddNewItem(item))
    }
  }

  handleItemChange = async (value, id, edit) => {
    const form = this.props.form
    const selectedItem = this.props.allItems.filter(
      row => parseInt(row.id, 0) === parseInt(value, 0)
    )
    if (selectedItem.length > 0) {
      let fieldsValue = {}
      fieldsValue[`description-${id}`] = selectedItem[0].description
      fieldsValue[`cost-${id}`] = selectedItem[0].cost
      form.setFieldsValue(fieldsValue)
      if (edit) {
        this.props.onChangeName(value, id)
        await this.props.onChangeItem(selectedItem[0].name, 'name', id)
        await this.props.onChangeItem(selectedItem[0].cost, 'cost', id)
        await this.props.onChangeItem(selectedItem[0].description, 'description', id)
      }
    }
  }

  editName = index => {
    this.setState({
      editMode: index
    })
  }

  onSectioNameKeyPress = event => {
    if (event.which === 13 || event.keyCode === 13) {
      this.setState({
        editMode: -1
      })
    }
  }

  /* item quick add actions */
  handleBlurItem = item => {
    if (item !== '')
      this.setState({
        itemQuickAddModal:
          _.findIndex(this.props.allItems, { id: +item }) < 0 &&
          _.findIndex(this.props.allItems, { name: item }) < 0
            ? true
            : false,
        itemName: item
      })
  }

  defineNewItem = item => {
    this.setState({
      newItem: item
    })
    const form = this.props.form
    form.setFieldsValue({
      item_id: item.name,
      description: item.description,
      cost: item.cost
    })
  }

  toggleItemQuickAdd = () => {
    const { itemQuickAddModal } = this.state

    this.setState({
      itemQuickAddModal: !itemQuickAddModal
    })
  }

  renderEditDescription = d => {
    const { getFieldDecorator } = this.props.form
    if (this.isEditAllowed()) {
      return (
        <FormItem>
          {getFieldDecorator(`description-${d.original.id}`, {
            rules: [
              {
                required: true,
                message: 'description cannot be blank.'
              }
            ],
            initialValue: d.original.description,
            onChange: e => this.props.onChangeItem(e.target.value, 'description', d.original.id)
          })(<Input placeholder="Type in the description..." rows={4} />)}
        </FormItem>
      )
    } else {
      return <Tooltip title={d.original.description}>{d.original.description}</Tooltip>
    }
  }

  getAutoCompleteItems = () => {
    if (Array.isArray(this.state.allItemsCache)) {
      return this.state.allItemsCache
    }
    const { allItems } = this.props
    const names = allItems.map(d => d.name)
    const items = _.uniq(names)
    this.setState({
      allItemsCache: items
    })
    return items
  }

  renderEditName = d => {
    const { allItems } = this.props
    const { getFieldDecorator } = this.props.form
    if (this.isEditAllowed()) {
      return (
        <FormItem>
          {getFieldDecorator(`item_id-${d.original.id}`, {
            initialValue: d.original.name,
            rules: [
              {
                required: true,
                message: 'Name cannot be blank.'
              }
            ]
          })(
            <AutoComplete
              dataSource={convertToOption(allItems)}
              filterOption={(inputValue, option) =>
                option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
              }
              onChange={e => this.handleItemChange(e, d.original.id, true)}
              placeholder="Search for an item"
              onBlur={e => this.handleBlurItem(e)}
            >
              <Input suffix={<Icon type="search" className="certain-category-icon" />} />
            </AutoComplete>
          )}
        </FormItem>
      )
    } else {
      return <Tooltip title={d.original.name}>{d.original.name}</Tooltip>
    }
  }

  renderEditCurrency = d => {
    const { getFieldDecorator } = this.props.form
    if (this.isEditAllowed()) {
      return (
        <FormItem>
          {getFieldDecorator(`cost-${d.id}`, {
            rules: [
              {
                required: true,
                message: 'Price cannot be blank.'
              }
            ],
            initialValue: d.cost,
            onChange: e => this.props.onChangeItem(e.target.value, 'cost', d.id)
          })(<Input min="0" type="number" placeholder="Cost" />)}
        </FormItem>
      )
    } else {
      return numeral(d.cost).format('$0,0.00')
    }
  }

  renderEditQuantity = d => {
    if (this.isEditAllowed()) {
      return (
        <Input
          min="0"
          type="number"
          value={d.quantity}
          placeholder="Quantity"
          onChange={value => this.props.onChangeItem(value.target.value, 'quantity', d.id)}
        />
      )
    } else {
      return d.quantity
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { section, index, allItems, sections, sectionId } = this.props
    const addItemsList = this.state.itemsToAdd.map((item, index) => (
      <div className="row purchaseOrderItems" key={index}>
        <div className="col-md-3">
          <FormItem label="Item Name">
            {getFieldDecorator(`item_id-${item.id}`, {
              rules: [
                {
                  required: true,
                  message: 'Name cannot be blank.'
                }
              ]
            })(
              <AutoComplete
                dataSource={convertToOption(allItems)}
                filterOption={(inputValue, option) =>
                  option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                }
                onChange={e => this.handleItemChange(e, item.id)}
                placeholder="Search for an item"
                onBlur={e => this.handleBlurItem(e)}
              >
                <Input suffix={<Icon type="search" className="certain-category-icon" />} />
              </AutoComplete>
            )}
          </FormItem>
        </div>
        <div className="col-md-3">
          <FormItem label="Description">
            {getFieldDecorator(`description-${item.id}`, {
              rules: [
                {
                  required: true,
                  message: 'description cannot be blank.'
                }
              ],
              initialValue: sections ? sections.description : ''
            })(<Input placeholder="Type in the description..." rows={4} />)}
          </FormItem>
        </div>
        <div className="col-md-2">
          <FormItem label="Quantity">
            {getFieldDecorator(`quantity-${item.id}`, {
              rules: [
                {
                  required: true,
                  message: 'Quantity cannot be blank.'
                }
              ],
              initialValue: sections ? sections.quantity : ''
            })(<InputNumber initialvalue={sections ? sections.quantity : ''} />)}
          </FormItem>
        </div>
        <div className="col-md-2">
          <FormItem label="Price">
            {getFieldDecorator(`cost-${item.id}`, {
              rules: [
                {
                  required: true,
                  message: 'Price cannot be blank.'
                }
              ],
              initialValue: sections ? sections.cost : ''
            })(
              <InputNumber
                formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              />
            )}
          </FormItem>
        </div>
        <div className="col-md-2 marginTop20">
          <Button className="marginTop18" icon="save" onClick={() => this.handleAddNewItem(item)} />
          <Button
            className="marginTop18 marginLeft10"
            icon="delete"
            onClick={() => this.removeAddItem(item)}
          />
        </div>
      </div>
    ))
    return (
      <div key={index}>
        <ItemQuickAdd
          visibility={this.state.itemQuickAddModal}
          toggleItemQuickAdd={this.toggleItemQuickAdd}
          createNewItem={this.props.createNewItem}
          defineNewItem={this.defineNewItem}
          itemName={this.state.itemName}
        />
        <Form layout="vertical">
          <div className="row padding0">
            <div className="col-md-12">
              <div className="purchaseOrderSection flexSpaceBetween">
                {this.state.editMode < 0 && (
                  <Tooltip title="Click to edit section name. Hit Enter to save.">
                    <div className="groupName" onClick={() => this.editName(index)}>
                      {section}
                    </div>
                  </Tooltip>
                )}
                {this.state.editMode === index && (
                  <div>
                    <Input
                      onChange={event => {
                        this.props.onSectionNameChange(index, event.target.value)
                      }}
                      onKeyPress={this.onSectioNameKeyPress}
                      width={300}
                      value={section}
                    />
                  </div>
                )}
                <div>
                  <Button
                    className="marginRight5"
                    icon="arrow-up"
                    onClick={() => this.props.moveSectionUp(index)}
                  />
                  <Button
                    className="marginRight5"
                    icon="arrow-down"
                    onClick={() => this.props.moveSectionDown(index)}
                  />
                  <Button
                    className="marginRight5"
                    icon="delete"
                    onClick={() => this.props.deleteSection(index)}
                  />
                </div>
              </div>
            </div>
          </div>
          {this.state.panel === 'TablePanel' && (
            <div>
              <div className="row padding0">
                <div className="col-md-12">
                  <ReactTable
                    showPagination={false}
                    defaultFilterMethod={filterCaseInsensitive}
                    columns={[
                      {
                        columns: [
                          {
                            Header: 'Name',
                            id: 'name',
                            accessor: 'name',
                            Cell: this.renderEditName,
                            width: 300
                          },
                          {
                            Header: 'Description',
                            id: 'description',
                            accessor: 'description',
                            Cell: this.renderEditDescription
                          },
                          {
                            Header: 'Cost',
                            id: 'cost',
                            accessor: this.renderEditCurrency,
                            width: 100,
                            className: 'textAlignRight'
                          },
                          {
                            Header: 'Quantity',
                            width: 80,
                            accessor: this.renderEditQuantity,
                            className: 'textAlignRight',
                            id: 'quantity'
                          },
                          {
                            Header: 'Grand Total',
                            id: 'grand_total',
                            accessor: d => numeral(d.cost * d.quantity).format('$0,0.00'),
                            width: 100,
                            className: 'textAlignRight'
                          },
                          {
                            Header: 'Actions',
                            accessor: 'actions',
                            Cell: d => (
                              <div>
                                <Button
                                  icon="caret-up"
                                  size="small"
                                  onClick={() =>
                                    this.props.moveItemUp(
                                      d.original.row_id || d.original.id || d.original.item_id
                                    )
                                  }
                                />
                                <Button
                                  icon="caret-down"
                                  size="small"
                                  onClick={() =>
                                    this.props.moveItemDown(
                                      d.original.row_id || d.original.id || d.original.item_id
                                    )
                                  }
                                />
                                <Popconfirm
                                  title="Are you sure you want to delete this line?"
                                  onConfirm={() =>
                                    this.props.deleteItem(
                                      d.original.row_id || d.original.id || d.original.item_id
                                    )
                                  }
                                  onCancel={this.cancelDelete}
                                  okText="Yes"
                                  cancelText="No"
                                >
                                  <Button
                                    size="small"
                                    className="marginLeft5"
                                    type="danger"
                                    icon="delete"
                                  />
                                </Popconfirm>
                              </div>
                            ),
                            width: 120
                          }
                        ]
                      }
                    ]}
                    data={this.getSectionItems(sectionId)}
                    noDataText="No items added yet"
                    pageSize={this.getSectionItems(sectionId).length}
                    className="-striped -highlight"
                  />
                </div>
              </div>
              {addItemsList}
              {this.state.itemsToAdd.length > 0 && (
                <div className="row padding0">
                  <div className="col-md-12 text-right marginTop10">
                    <Button icon="save" onClick={() => this.saveAllItems()}>
                      Save all items
                    </Button>
                  </div>
                </div>
              )}
              <div className="row padding0">
                <div className="col-md-12 text-right marginTop10">
                  <Button icon="plus" onClick={() => this.addItem()}>
                    Add New Item
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Form>
      </div>
    )
  }
}

export default Form.create()(PurchaseOrderSection)



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderSection.js